(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ae-best-kauf"] && !Shopify.designMode) return;
  try {
    
/* AE Gewährleistungsbutton: unabhängiger Dialog, keine Warenkorb-Aktion. */

  if (!customElements.get('ae-bestseller-notice')) {
    customElements.define('ae-bestseller-notice', class extends HTMLElement {
      connectedCallback() {
        this.setup();
        if (!this.dataset.ready) {
          this.observer = new MutationObserver(() => this.setup());
          this.observer.observe(this, {childList: true, subtree: true});
        }
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        const dialog = this.querySelector('dialog');
        if (dialog && dialog.open) dialog.close();
      }
      setup() {
        if (this.dataset.ready) return;
        const link = this.querySelector('.ae-bestseller-notice__trigger');
        const dialog = this.querySelector('dialog');
        const close = this.querySelector('[data-notice-close]');
        if (!link || !dialog || !close || typeof dialog.showModal !== 'function') return;
        this.dataset.ready = 'true';
        if (this.observer) this.observer.disconnect();
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', (event) => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (!dialog.open) dialog.showModal();
        });
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => { if (link.isConnected) link.focus(); });
      }
    });
  }



/* Bestseller V5. No product handles, variant IDs or prices are hardcoded. */

(() => {

  if (customElements.get('ae-bk-buy')) return;

  const q = (el, name) => el.querySelector(`[data-${name}]`);

  const scrollToPurchase = el => {

    el.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});

  };

  class BestsellerBuy extends HTMLElement {

    connectedCallback() {

      if (this.ready) return;

      const script = q(this, 'product-data');

      if (!script) { setTimeout(() => { if (this.isConnected) this.connectedCallback(); }, 0); return; }

      try { this.data = JSON.parse(script.textContent); } catch { return; }

      this.products = this.data.products.filter((p, i, a) => p && a.findIndex(x => String(x.id) === String(p.id)) === i);

      if (!this.products.length) return;

      this.ready = true;

      this.controller = new AbortController();

      const on = (el, event, fn) => el?.addEventListener(event, fn, {signal: this.controller.signal});

      this.packSelect = q(this, 'package');

      this.variantSelect = q(this, 'variant');

      this.quantity = q(this, 'quantity-input');

      this.form = q(this, 'purchase');

      this.addon = q(this, 'addon');

      this.addonVariant = q(this, 'addon-variant');

      this.error = q(this, 'error');

      this.button = q(this, 'submit');

      this.formatter = new Intl.NumberFormat(this.dataset.locale || 'de-DE', {style: 'currency', currency: this.dataset.currency || 'EUR'});

      this.packSelect.replaceChildren(...this.products.map(p => {

        const option = new Option(p.title, String(p.id)); return option;

      }));

      q(this, 'package-picker').hidden = false;

      if (this.data.addon && this.addonVariant) this.populateVariants(this.addonVariant, this.data.addon);

      on(this.packSelect, 'change', () => this.selectPack(this.packSelect.value));

      on(this.variantSelect, 'change', () => { this.error.textContent = ''; this.update(); this.showVariantImage(); });

      on(this.addonVariant, 'change', () => { this.error.textContent = ''; this.update(); });

      on(this.addon, 'change', () => { this.error.textContent = ''; this.update(); });

      on(this.quantity, 'input', () => this.update(false));

      on(this.quantity, 'change', () => this.update(true));

      this.querySelectorAll('[data-quantity]').forEach(button => on(button, 'click', () => {

        const v = this.variant(); if (!v) return;

        this.quantity.value = this.normalizeQuantity(Number(this.quantity.value || v.min || 1) + Number(button.dataset.quantity) * Number(v.step || 1), v);

        this.update();

      }));

      on(q(this, 'upsell-button'), 'click', () => { if (this.products[1]) this.selectPack(String(this.products[1].id)); });

      on(q(this, 'thumbnails'), 'click', e => { const button = e.target.closest('[data-photo-index]'); if (button) this.showImage(Number(button.dataset.photoIndex)); });

      on(q(this, 'zoom'), 'click', () => {

        const img = q(this, 'zoom').querySelector('img'); if (!img?.src) return;

        const dialog = q(this, 'zoom-dialog'); const large = q(this, 'zoom-image');

        large.src = img.currentSrc || img.src; large.alt = img.alt;

        if (!dialog.open) dialog.showModal();

      });

      on(q(this, 'close'), 'click', () => q(this, 'zoom-dialog').close());

      on(q(this, 'zoom-dialog'), 'click', e => {

        if (e.target !== e.currentTarget) return;

        const r = e.currentTarget.getBoundingClientRect();

        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) e.currentTarget.close();

      });

      on(window, 'ae:bestseller:select', e => {

        if (e.detail.handled || !this.products.some(p => String(p.id) === String(e.detail.productId))) return;

        e.detail.handled = true;

        this.selectPack(String(e.detail.productId)); scrollToPurchase(this.form); this.packSelect.focus({preventScroll: true});

      });

      on(this.form, 'submit', e => this.submit(e));

      this.selectPack(String(this.products[0].id), true);

      if (this.dataset.sticky === 'true' && 'IntersectionObserver' in window) {

        this.observer = new IntersectionObserver(entries => {

          const entry = entries[0];

          q(this, 'sticky-bar').hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;

        }, {threshold: 0});

        this.observer.observe(this.form);

      }

    }

    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); this.ready = false; }

    money(value) { return this.formatter.format(Number(value) / 100); }

    variant() { return this.current?.variants.find(v => String(v.id) === this.variantSelect.value); }

    addonV() { return this.data.addon?.variants.find(v => String(v.id) === this.addonVariant?.value); }

    populateVariants(select, product) {

      select.replaceChildren(...product.variants.map(v => new Option(

        (v.title === 'Default Title' ? product.title : v.title) + ' · ' + this.money(v.price) + (v.available ? '' : ' · Ausverkauft'), String(v.id)

      )));

      const preferred = product.variants.find(v => String(v.id) === String(product.initialVariant)) || product.variants.find(v => v.available) || product.variants[0];

      if (preferred) select.value = String(preferred.id);

    }

    selectPack(id, initial = false) {

      const product = this.products.find(p => String(p.id) === String(id)); if (!product) return;

      this.current = product; this.packSelect.value = String(product.id);

      this.populateVariants(this.variantSelect, product);

      q(this, 'variant-picker').hidden = product.variants.length === 1 && product.variants[0].title === 'Default Title';

      if (this.addon) this.addon.checked = false;

      this.error.textContent = '';

      this.renderGallery(initial);

      this.update(); this.showVariantImage();

      this.dispatchEvent(new CustomEvent('ae:bestseller:changed', {bubbles: true, detail: {productId: product.id}}));

    }

    normalizeQuantity(raw, v) {

      const min = Number(v.min || 1), step = Number(v.step || 1);

      let n = Number(raw); if (!Number.isFinite(n)) n = min;

      n = min + Math.max(0, Math.round((n - min) / step)) * step;

      if (v.max != null) n = Math.min(n, min + Math.max(0, Math.floor((Number(v.max) - min) / step)) * step);

      return n;

    }

    update(normalize = true) {

      const p = this.current, v = this.variant(); if (!v) return;

      this.quantity.min = v.min || 1; this.quantity.step = v.step || 1;

      if (v.max != null) this.quantity.max = v.max; else this.quantity.removeAttribute('max');

      const quantity = this.normalizeQuantity(this.quantity.value, v);

      if (normalize) this.quantity.value = quantity;

      const av = this.addonV();

      const canAddon = !!(this.data.addon && av && !p.holders && String(this.data.addon.id) !== String(p.id) && !this.data.addon.requiresSellingPlan);

      if (this.addon) {

        q(this, 'addon-row').hidden = !canAddon;

        this.addon.disabled = !canAddon || !av.available;

        if (this.addon.disabled) this.addon.checked = false;

        q(this, 'addon-price').textContent = av ? '+ ' + this.money(av.price) + (av.available ? '' : ' · Aktuell ausverkauft') : '';

        q(this, 'addon-variant-wrap').hidden = !canAddon || this.data.addon.variants.length < 2;

      }

      const extra = !!(canAddon && av.available && this.addon?.checked);

      const total = (v.price + (extra ? av.price : 0)) * quantity;

      q(this, 'total').textContent = this.money(total);

      q(this, 'package-info').textContent = p.contents || '';

      q(this, 'package-selection').textContent = p.id === this.products[0].id ? 'Einzelspiel ausgewählt' : 'Set ausgewählt – ersetzt das Einzelspiel';

      q(this, 'included').hidden = !p.holders;

      q(this, 'included').textContent = p.holders === 1 ? '1 Holz-Kartenhalter bereits im Set enthalten.' : p.holders + ' Holz-Kartenhalter bereits im Set enthalten.';

      const canBuy = v.available && !p.requiresSellingPlan;

      this.button.disabled = this.pending || !canBuy;

      q(this, 'submit-label').textContent = this.pending ? 'Wird hinzugefügt …' : p.requiresSellingPlan ? 'Bitte auf Produktseite wählen' : !v.available ? 'Aktuell ausverkauft' : p.id === this.products[0].id ? 'In den Warenkorb' : 'Set in den Warenkorb';

      q(this, 'sticky-title').textContent = p.title + ' · ' + this.money(total);

      q(this, 'gallery-caption').textContent = 'Ausgewählt: ' + p.title;

      this.products.forEach(product => {

        const option = [...this.packSelect.options].find(o => o.value === String(product.id));

        const price = Math.min(...product.variants.map(v => v.price));

        const varies = product.variants.some(v => v.price !== price);

        if (option) option.textContent = product.title + ' · ' + (varies ? 'ab ' : '') + this.money(price) + (product.variants.some(v => v.available) ? '' : ' · Ausverkauft');

      });

      const upgrade = this.products[1], upgradeV = upgrade?.variants.find(v => v.available);

      const teaser = q(this, 'upsell');

      teaser.hidden = p.id !== this.products[0].id || !upgradeV || !v.available || upgrade.requiresSellingPlan;

      if (!teaser.hidden) {

        q(this, 'upsell-copy').textContent = upgrade.title + ' · ' + this.money(upgradeV.price) + ' je Set';

        const delta = upgradeV.price - v.price;

        q(this, 'upsell-button').textContent = (delta > 0 ? 'Für ' + this.money(delta) + ' mehr je Set ' : '') + 'zum ' + upgrade.title + ' wechseln →';

      }

    }

    renderGallery(initial) {

      const photos = this.current.images || [];

      q(this, 'thumbnails').replaceChildren(...photos.map((photo, index) => {

        const button = document.createElement('button'); button.type = 'button'; button.className = 'thumb'; button.dataset.photoIndex = index;

        button.setAttribute('aria-label', `Bild ${index + 1} anzeigen`); button.setAttribute('aria-pressed', String(index === 0));

        const img = document.createElement('img'); img.src = photo.thumb || photo.src; img.alt = photo.alt || this.current.title; img.loading = 'lazy'; img.width = 65; img.height = 65;

        button.append(img); return button;

      }));

      const stage = q(this, 'zoom');

      if (!photos.length) {

        stage.replaceChildren(); const text = document.createElement('span'); text.textContent = 'Produktbild folgt'; stage.append(text); stage.disabled = true;

      } else { stage.disabled = false; if (!initial || !stage.querySelector('img')) this.showImage(0); }

    }

    showImage(index) {

      const photo = this.current.images[index]; if (!photo) return;

      const image = document.createElement('img'); image.src = photo.src; image.alt = photo.alt || this.current.title; image.width = 1400; image.height = 1400; image.decoding = 'async';

      q(this, 'zoom').replaceChildren(image);

      q(this, 'thumbnails').querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.photoIndex) === index)));

    }

    showVariantImage() {

      const v = this.variant(); if (!v?.image) return;

      const index = this.current.images.findIndex(p => p.src === v.image);

      if (index >= 0) this.showImage(index);

    }

    async submit(e) {

      e.preventDefault(); if (this.pending) return;

      this.update(); const v = this.variant();

      if (!v?.available || this.current.requiresSellingPlan || !this.form.reportValidity()) return;

      const quantity = Number(this.quantity.value), items = [{id: v.id, quantity}];

      if (this.addon?.checked && !this.addon.disabled) {

        const av = this.addonV();

        const valid = av?.available && quantity >= (av.min || 1) && (av.max == null || quantity <= av.max) && (quantity - (av.min || 1)) % (av.step || 1) === 0;

        if (!valid) { this.error.textContent = 'Diese Anzahl ist für den zusätzlichen Kartenhalter nicht verfügbar. Bitte Anzahl oder Zusatz anpassen.'; return; }

        items.push({id: av.id, quantity});

      }

      // This attribute is added only to the separate local design preview.

      if (this.hasAttribute('data-preview')) {

        this.dispatchEvent(new CustomEvent('ae:bestseller:preview-add', {bubbles: true, detail: {items, title: this.current.title, total: q(this, 'total').textContent}}));

        return;

      }

      this.pending = true; this.error.textContent = ''; this.form.setAttribute('aria-busy', 'true'); this.update();

      try {

        const response = await fetch(this.dataset.addUrl, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});

        const result = await response.json();

        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'Die Auswahl konnte nicht vollständig hinzugefügt werden. Bitte prüft euren Warenkorb.');

        window.location.assign(this.dataset.cartUrl);

      } catch (error) {

        this.error.replaceChildren(document.createTextNode((error?.message || 'Die Verbindung wurde unterbrochen.') + ' '));

        const link = document.createElement('a'); link.href = this.dataset.cartUrl; link.textContent = 'Warenkorb prüfen'; this.error.append(link);

        this.pending = false; this.form.removeAttribute('aria-busy'); this.update();

      }

    }

  }

  customElements.define('ae-bk-buy', BestsellerBuy);

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ae-best-sets"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ae-bk-sets')) return;
  class BestsellerSets extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      this.addEventListener('click', e => {
        const link = e.target.closest('[data-select-product]'); if (!link || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || e.button) return;
        const detail = {productId: link.dataset.selectProduct, handled: false};
        window.dispatchEvent(new CustomEvent('ae:bestseller:select', {detail}));
        if (detail.handled) e.preventDefault();
      }, {signal: this.controller.signal});
      const update = id => this.querySelectorAll('[data-select-product]').forEach(link => {
        const selected = String(link.dataset.selectProduct) === String(id);
        if (selected) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        link.textContent = selected ? 'Ausgewählt ✓' : 'Dieses Set wählen →';
      });
      document.addEventListener('ae:bestseller:changed', e => update(e.detail.productId), {signal: this.controller.signal});
      const buy = document.querySelector('ae-bk-buy'); if (buy?.current) update(buy.current.id);
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('ae-bk-sets', BestsellerSets);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bk-kontakt"] && !Shopify.designMode) return;
  try {
    
  /* Progressive enhancement only: sending, validation and CAPTCHA remain native. */
  if (!customElements.get('bk-contact-section')) {
    customElements.define('bk-contact-section', class extends HTMLElement {
      connectedCallback() {
        if (this.bkFrame) cancelAnimationFrame(this.bkFrame);
        this.bkFrame = requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (!this.isConnected) return;
        if (this.bkController) this.bkController.abort();
        this.bkController = new AbortController();
        const { signal } = this.bkController;
        const select = this.querySelector('[data-bk-topic-select]');
        const area = this.querySelector('[data-bk-form-area]');
        const sync = () => {
          this.querySelectorAll('[data-bk-topic]').forEach(link => {
            link.dataset.selected = String(Boolean(select && select.value && link.dataset.bkTopic === select.value));
          });
        };
        this.addEventListener('click', event => {
          const link = event.target instanceof Element ? event.target.closest('[data-bk-topic]') : null;
          if (!link || !this.contains(link) || !select || !area || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const option = Array.from(select.options).find(item => item.value === link.dataset.bkTopic);
          if (!option) return;
          event.preventDefault();
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          select.focus({ preventScroll: true });
          area.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }, { signal });
        if (select) select.addEventListener('change', sync, { signal });
        sync();
        const feedback = this.querySelector('[data-bk-form-feedback]');
        if (feedback && !(window.Shopify && window.Shopify.designMode)) {
          feedback.focus({ preventScroll: true });
          feedback.scrollIntoView({ behavior: 'auto', block: 'center' });
        }
      }
      disconnectedCallback() {
        if (this.bkFrame) cancelAnimationFrame(this.bkFrame);
        if (this.bkController) this.bkController.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weihnachten-empfehlung"] && !Shopify.designMode) return;
  try {
    
  /* Nur Variantenpreis aktualisieren. Kein AJAX, kein manueller Tracking-Aufruf. */
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-bk-xg-variant]')) return;
    var section = select.closest('.bk-xmas-gift');
    var option = select.options[select.selectedIndex];
    if (!section || !option) return;
    var price = section.querySelector('[data-bk-xg-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    var button = section.querySelector('button[name="add"]');
    if (button) button.disabled = option.disabled;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weihnachten-geschenksets"] && !Shopify.designMode) return;
  try {
    
  // Nur die Anzeige bei einem Variantenwechsel aktualisieren.
  // Das Hinzufügen bleibt ein regulärer Shopify-Formular-POST.
  document.addEventListener('change', function (event) {
    if (!(event.target instanceof HTMLSelectElement)) return;
    const select = event.target;
    if (!select.matches('.bk-xmas-sets [data-bk-xs-variant]')) return;
    const card = select.closest('.bk-xs__card');
    const option = select.selectedOptions[0];
    if (!card || !option) return;
    const price = card.querySelector('[data-bk-xs-price]');
    const button = card.querySelector('[data-bk-xs-add]');
    const label = card.querySelector('[data-bk-xs-button-label]');
    const productLink = card.querySelector('[data-bk-xs-product-link]');
    const quantity = card.querySelector('input[name="quantity"]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    const available = option.dataset.available === 'true';
    const needsOptions = Number(option.dataset.min || 1) > 1;
    if (button) {
      button.disabled = !available || needsOptions;
      const text = !available ? 'Aktuell nicht verfügbar' : needsOptions ? 'Bitte Kaufoptionen im Shop wählen' : button.dataset.addLabel;
      if (label) label.textContent = text;
      button.setAttribute('aria-label', text + ': ' + button.dataset.productTitle);
    }
    if (quantity) quantity.value = '1';
    if (productLink) {
      const url = new URL(productLink.dataset.productUrl, document.baseURI);
      url.searchParams.set('variant', option.value);
      productLink.href = url.pathname + url.search + url.hash;
    }
  });

  // Im Theme-Editor ausgewählte Karte auch im mobilen Slider zeigen.
  document.addEventListener('shopify:block:select', function (event) {
    if (!(event.target instanceof Element)) return;
    const card = event.target.closest('.bk-xs__card');
    if (!card) return;
    const grid = card.closest('.bk-xs__grid');
    if (!grid || grid.scrollWidth <= grid.clientWidth) return;
    const offset = card.getBoundingClientRect().left - grid.getBoundingClientRect().left;
    grid.scrollBy({ left: offset, behavior: 'auto' });
  });

  } catch(e) { console.error(e); }
})();
})();
